import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconImport2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"import-2, download, save"} maskId="square-filled-radius-0-stroke-1-IconImport2"><path d="M17.0001 4C13.9625 4 11.5001 6.46243 11.5001 9.5V14.0429L8.25008 10.7929L7.54297 11.5L12.0001 15.9571L16.4572 11.5L15.7501 10.7929L12.5001 14.0429V9.5C12.5001 7.01472 14.5148 5 17.0001 5H22.0001V4H17.0001Z" fill="currentColor"/><path d="M2 4V20H22V8H21V19H3V5H9V4H2Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconImport2;
